import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance from '../../api/axiosInstance';
import '../../styles/modal.css';
// import { toast } from 'react-toastify'; // Commented out - using react-toast now
import { toast } from 'react-toast';

const JiraConfigModal = ({ isOpen, onClose, onConnectSuccess, isEditMode = false, initialCredentials = null }) => {
  const [formData, setFormData] = useState({
    domain: '',
    email: '',
    api_token: '',
    is_connected: true
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  // Prefill form data when in edit mode
  useEffect(() => {
    if (isEditMode && initialCredentials) {
      setFormData({
        domain: initialCredentials.domain || '',
        email: initialCredentials.email || '',
        api_token: '', // Don't prefill API token for security
        is_connected: initialCredentials.is_connected || true
      });
    } else {
      // Reset form when not in edit mode
      setFormData({
        domain: '',
        email: '',
        api_token: '',
        is_connected: true
      });
    }
  }, [isEditMode, initialCredentials, isOpen]); 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

   const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setSuccessMessage(null); 
    
    try {
      let response;
      
      if (isEditMode) {
        // Update existing credentials
        // Only include api_token if it's provided in edit mode
        const updatePayload = { ...formData };
        if (!updatePayload.api_token) {
          delete updatePayload.api_token;
        }
        
        response = await axiosInstance.put('/jira_dataupdate_credentials', updatePayload);
        toast.success('JIRA credentials updated successfully');
      } else {
        // Create new credentials (existing logic)
        const authDataString = localStorage.getItem('user');
        if (!authDataString) {
          throw new Error('User not authenticated');
        }
        
        const authData = JSON.parse(authDataString);
        const accessToken = authData.accessToken;
        
        response = await axios.post(
           `${process.env.REACT_APP_BASE_URL}/jira_datasave_credentials`,
          formData,
          {
            headers: {
              'token': `${accessToken}`,
              'Content-Type': 'application/json'
            }
          }
        );
        toast.success('JIRA credentials saved successfully');
      }

      onConnectSuccess();
      onClose();
    } catch (err) {
      const errorMessage = err.response?.data?.detail || err.response?.data?.message || err.message || 
        `Failed to ${isEditMode ? 'update' : 'save'} JIRA credentials`;
      setError(errorMessage);
      console.error(`Error ${isEditMode ? 'updating' : 'saving'} JIRA credentials:`, err);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div data-rt-modal-overlay className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) { const b = e.currentTarget.querySelector('[data-rt-modal-close], .close-btn, .modal-close, button[aria-label="Close"], button[aria-label="close"]'); if (b) b.click(); } }}>
      <div className="modal create-project-modal">
        <div className="modal-header">
          <h2>{isEditMode ? 'Edit JIRA Integration' : 'Configure JIRA Integration'}</h2>
          <button className="modal-close" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">JIRA Domain</label>
              <input
                style={{width:'100%'}}
                type="url"
                name="domain"
                value={formData.domain}
                onChange={handleChange}
                className="form-input"
                placeholder="https://your-domain.atlassian.net"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                style={{width:'100%'}}
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
                placeholder="your@email.com"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">API Token</label>
              <input
                style={{width:'100%'}}
                type="password"
                name="api_token"
                value={formData.api_token}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter your JIRA API token"
                required
              />
              <div className="form-hint">
                <a 
                  href="https://support.atlassian.com/atlassian-account/docs/manage-api-tokens/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  How to get API token?
                </a>
                {/* {isEditMode && (
                  <div style={{ marginTop: '4px', color: '#666' }}>
                    Leave empty to keep current API token
                  </div>
                )} */}
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={onClose} disabled={isLoading}>
                Cancel
              </button>
              <button
                type="submit"
                className="btn-primary"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner"></span> {isEditMode ? 'Updating...' : 'Saving...'}
                  </>
                ) : (
                  isEditMode ? 'Update Configuration' : 'Save Configuration'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default JiraConfigModal;